<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />

    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/shera/AboutInstructor.vue'

import TestimonialCompany from '../../components/shera/CompnayTestimonial.vue'
import Landing from '../../components/LcpAsessment/Landing.vue'
import ProgramInfo from '../../components/shera/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import BasicRequirement from '../../components/LcpAsessment/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title: 'Your first step towards a Junior Product Manager Position',
        paragraph:
          'Upskill presents this  assessment only designed for Junior Product Manager Take part in this assessment, and get a chance to work at LightCastle Partners (LCP). Based on experience the salary will be Tk 40k-65k',
        companyLogo: require('../../assets/lcp/lcp_logo.png'),
        quizLink:
          'https://quiz.upskill.com.bd/assessment/cdf11f63-fd0a-4552-9db1-04635524f759?public=true&job=Assessment_Lcp_ProductManager',
        landingImage: require('../../assets/shera/landing.png'),
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../assets/lcp/lcp_logo_updated.png'),
        info:
          'LightCastle Partners envisions a knowledge-driven economy that inspires businesses and changes lives.Our entrepreneurial journey started back in 2013 with a simple vision: to inspire businesses in Bangladesh to advance the economy. Till date, we have consulted for 150+ development partners & private organizations on 250+ projects, collaborated with 500+ SMEs & startups, mobilized U$ 50 million+ in investments and supported 40+ accelerator/incubator programs across Bangladesh. LightCastle also hosts the largest market and industry datasets in Bangladesh across 30+ industries.We believe the Bangladesh opportunity is exciting – led by your goals and accomplishments. And to that end, we are here to support and collaborate.',
        designation: '',

        bgColor: '#B70000',
      },
      programData: {
        headingInfo:
          'Assessment Test for the role of Junior Product Manager at LightCastle Partners (LCP) consists of approximately 10 MCQs. You are required to pass an assessment test with a minimum 60% of the total score.',
        seatsInfo:
          'Top 5-10 Candidates will get the chance to go to the interview round directly after completing the assessment..',
        startDate: '30th January',
        cost: 'Free',
        deadline: '7th February',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/cdf11f63-fd0a-4552-9db1-04635524f759?public=true&job=Assessment_Lcp_ProductManager',
        bgColor: '#1EBCE5',
        txtColor: '#00A653',
      },
      companyTestimonial: {
        mainImg: require('../../assets/lcp/bijon.png'),
        name: 'Bijon Islam',
        paragraph:
          'At LightCastle we are looking for team members who are passionate about their work - trying to become the best at what they do. For the Junior Product Manager role we need a person who can understand B2B client needs and acts as a go between Business and Tech team.',
        designation: 'CEO of Light Castle Partners',
        invertedCommaBg: '',
      },
      basicRequirement: {
        mainContent: [],
        bgColor: '',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Have A Minimum 1 Year Of Product Or UI/UX Design Experience As An Employee Or Freelancer. \n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'No, the top 5 students will get a chance to interview at LCP, and will get the job depending on their performance in the interview..\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: '40k-65k \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
  },
  created() {
    this.Loaded()
  },
}
</script>
